import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { volumes } from "../../data/content";
export function Volumes() {
  return <section className="px-4 py-16 md:py-24" aria-labelledby="volumes-title" data-id="element-297" data-mp="2wzp1oszvozea">
      <div className="mx-auto max-w-6xl" data-id="element-298" data-mp="2syn0w7qbcfa7">
        <SectionHeading eyebrow="What you'll find inside" title={<span id="volumes-title" data-id="element-300" data-mp="2o1wnjs5w7xsh">
              6 Premium Volumes that take you from <em className="text-brand-600" data-id="element-301" data-mp="2j93hn0youjet">concern</em> to{" "}
              <em className="text-brand-600" data-id="element-302" data-mp="2ea8y1wswcqtn">clinical step</em>
            </span>} data-id="element-299" data-mp="2t1refvpo4ndj" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-303" data-mp="29c7ezbvh0ri6">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_1px_0_rgba(28,22,51,0.06),0_12px_32px_-16px_rgba(28,22,51,0.18)]" data-id="element-304" data-mp="25alup5glxaxy">
              <div className="px-6 pb-5 pt-6" style={{
            backgroundColor: v.tint
          }} data-id="element-305" data-mp="334l1v12n7p29">
                <span className="inline-block rounded-md px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" style={{
              backgroundColor: v.color
            }} data-id="element-306" data-mp="37wmb0e4ikzo2">
                  {v.number}
                </span>
                <h3 className="mt-3 font-serif text-2xl font-black leading-tight text-ink md:text-[1.7rem]" data-id="element-307" data-mp="3lw45990kx54t">{v.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-308" data-mp="3qvqgjcwukbaz">{v.intro}</p>
              </div>
              <div className="flex flex-1 flex-col px-6 pb-6 pt-5" data-id="element-309" data-mp="3cw8p0ps62jxx">
                <p className="text-sm font-bold text-ink" data-id="element-310" data-mp="3huikz2lptokl">{v.listLabel}</p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-311" data-mp="3hspepof0l6d4">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] leading-snug text-ink" data-id="element-312" data-mp="21id6r85ytv2h">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                  color: v.color
                }} strokeWidth={3} aria-hidden="true" data-id="element-313" data-mp="26d0qktq0y1aq" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-auto pt-5" data-id="element-314" data-mp="28tsws1pntgs">
                  <p className="flex gap-3 rounded-2xl border border-dashed p-4 text-[15px] font-semibold leading-snug text-ink" style={{
                borderColor: v.color
              }} data-id="element-315" data-mp="27irgyvqmxsu">
                    <TargetIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-316" data-mp="3pebb4984y5m3" />
                    {v.goal}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-317" data-mp="3fhotruf0pwot">
          <CtaButton label="I want all 6 volumes" data-id="element-318" data-mp="3bes45jr290bd" />
        </div>
      </div>
    </section>;
}